module.exports = __webpack_public_path__ + "media/images/home/main/aa/6-876172bc405904ffde456539260fd73b.png";